import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  private _config: Config = new Config();

  constructor(private http: HttpClient) { }

   /**
  *
  * @param id
  */
  public visualizar(params: object = null): Observable<any>  {
    return this.http.post<any>(`${this._config.get('urlServiceBackend')}empresa/visualizar`, params);
  }

 /**
  *
  * @param filtros
  * @param page
  * @param perPage
  */
  public listar(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any>  {
      perPage = perPage == undefined ? '' : perPage;
      let params = new HttpParams();
      params = params.append('page', page.toString());

      return this.http.post<any>(`${this._config.get('urlServiceBackend')}empresa/listar${perPage != null ? '/' + perPage : ''}`, filtros, {params: params});
  }

  /**
  *
  * @param filtros
  * @param page
  * @param perPage
  */
  public listarMatriz(): Observable<any>  {
    return this.http.post<any>(`${this._config.get('urlServiceBackend')}empresa/listarmatriz`, {params: ''});
  }

  /**
  *
  * @param filtros
  * @param page
  * @param perPage
  */
  public visualizarLista(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any>  {
    perPage = perPage == undefined ? '' : perPage;
    let params = new HttpParams();
    params = params.append('page', page.toString());

    return this.http.post<any>(`${this._config.get('urlServiceBackend')}empresa/visualizar-lista${perPage != null ? '/' + perPage : ''}`, filtros, {params: params});
  }

   /**
  *
  * @param filtros
  * @param page
  * @param perPage
  */
  public listaMunicipiosMapeados(filtros: object = null, page: number|string = 1, perPage: number|string = null): Observable<any>  {
    perPage = perPage == undefined ? '' : perPage;
    let params = new HttpParams();
    params = params.append('page', page.toString());

    return this.http.post<any>(`${this._config.get('urlServiceBackend')}empresa/municipiosvinculados${perPage != null ? '/' + perPage : ''}`, filtros, {params: params});
  }

    /**
     * Busca as empresas que estao vinculadas a um grupo
     */
  public buscarEmpresasVinculadasGrupo() {
      return this.http.post<any>(`${this._config.get('urlServiceBackend')}empresa/buscar-grupos`, {params: ''});
  }
}
